import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-6" }
const _hoisted_2 = { class: "mt-0 mb-4 d-flex justify-center" }
const _hoisted_3 = { class: "text-title-large d-flex justify-center text-red" }

import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModalContent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.registerModal.body')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.registerModal.announce')), 1)
  ]))
}
}

})